import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'atn-datagrid-header',
  templateUrl: './datagrid-header.component.html',
  styleUrls: ['./datagrid-header.component.scss']
})
export class DatagridHeaderComponent implements OnInit {
  @Input() name: string;

  ngOnInit() {}
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/datagrid/datagrid-header/datagrid-header.component.ts